module.exports = __webpack_public_path__ + "img/hk.7bb4c68d.svg";